import { render } from "./RegionDashboardsRatingList.vue?vue&type=template&id=3793918c&scoped=true&ts=true"
import script from "./RegionDashboardsRatingList.vue?vue&type=script&lang=ts"
export * from "./RegionDashboardsRatingList.vue?vue&type=script&lang=ts"

import "./RegionDashboardsRatingList.vue?vue&type=style&index=0&id=3793918c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3793918c"]])

export default __exports__